module.exports = __webpack_public_path__ + "static/img/Jake.Melksham.e676f96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake.Melksham.jpg
// module id = GpB2
// module chunks = 0